import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import ProjectRoleListUI from '../../components/projectapp/project/ProjectRoleListUI'

const ProjectRoleListPageUI = ({context, messageList, errorList, projectList, filteredProjectList,
    // refresh, filter
    onRefreshClick, searchFilter, onSearchFilterChange,
    // join, leave
    onJoinClick, onLeaveClick
  }) =>
  <PrivatePageSF context={context} className='pg_prj_role' backLink='/settings/user'
    messageList={messageList} headerMessageKey='c_connected_projects'
    centered={!projectList || (errorList && errorList.length > 0)}
  >
    {
      !projectList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      projectList && filteredProjectList &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/user'
          messageList={messageList} titleMessageKey='c_connected_projects'
        />
        <ProjectRoleListUI
          context={context}
          messageList={messageList}
          filteredProjectList={filteredProjectList}
          // refresh, filter
          onRefreshClick={onRefreshClick}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          // join, leave
          onJoinClick={onJoinClick}
          onLeaveClick={onLeaveClick}
        />
      </div>
    }
  </PrivatePageSF>

export default ProjectRoleListPageUI
